export const isOptionSelected = (option, selectedOptions) =>
  Array.isArray(option)
    ? option.every(o => (selectedOptions || []).includes(o))
    : (selectedOptions || []).includes(option);
